import { createContext, useContext } from 'react';
import ApiClient from './ApiClient';

export const ApiClientContext = createContext<ApiClient | null>(null);

export const useApiClient = () => {
  const ctx = useContext(ApiClientContext);
  if (!ctx) throw new Error('ApiClientContext not available');
  return ctx;
};
